var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlashbang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M5.472.132a.884.884 0 0 0-.87.735L4.587.851l-1.07.005-.172.095v.588l.13.08v.968l-.31-.009-.402.131-.008.958.393.23v3.104l-.393.235.016.931.376.205 1.669-.008.387-.172.009-.956-.396-.235V3.897l.396-.23v-.892l-.394-.188h-.23v-.968l.084-.103.874 1.13.007 3.82.385-.009-.045-3.935-.488-.625a.884.884 0 0 0 .066.002.884.884 0 0 0 .884-.883.884.884 0 0 0-.884-.884Zm0 .295a.59.59 0 0 1 .59.59.59.59 0 0 1-.59.588.59.59 0 0 1-.589-.589.59.59 0 0 1 .59-.589Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashbang);
export default __webpack_public_path__ + "static/media/flashbang.68863cb6f98917f4445398e38eb14e67.svg";
export { ForwardRef as ReactComponent };